import { X } from "@phosphor-icons/react";
import { type ReactNode, useState } from "react";

import { Button } from "common/components/ui/Button";
import useExternalCouponState from "common/hooks/useExternalCouponState";

const couponNameClassname = "text-yellow-400 text-sm-bold";

export default function CouponBanner() {
  const { couponState, clearCoupon } = useExternalCouponState();
  const [isOpen, setIsOpen] = useState(!!couponState);

  function onClose() {
    clearCoupon();
    setIsOpen(false);
  }

  //sometimes coupon is undefined, after it gets removed
  if (isOpen && !!couponState) {
    const { couponCode, isCouponApplied, couponError } = couponState;
    const uppercaseCoupon = couponCode.toUpperCase();
    let bannerContent: ReactNode;

    if (couponError) {
      bannerContent = (
        <>
          Failed to apply coupon{" "}
          <span className={couponNameClassname}>{uppercaseCoupon}</span> to free
          trial subscription. Contact support if you think this is a mistake
        </>
      );
    } else if (isCouponApplied) {
      bannerContent = (
        <>
          Coupon <span className={couponNameClassname}>{uppercaseCoupon}</span>{" "}
          has been applied to your free trial subscription
        </>
      );
    } else {
      bannerContent = (
        <span>
          Coupon <span className={couponNameClassname}>{uppercaseCoupon}</span>{" "}
          available - it will be added automatically when you manage a
          subscription
        </span>
      );
    }

    return (
      <div className="flex h-12 shrink-0 text-sm-medium text-white relative items-center justify-center bg-cover bg-[url(/images/coupon-banner-bg.png)]">
        <div className="flex items-center gap-x-1.5">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>coupon icon</title>
            <path
              d="M2.1875 1.96289H9.43066C9.54157 1.9626 9.65143 1.98393 9.75391 2.02637C9.85663 2.06896 9.95 2.13199 10.0283 2.21094L17.7881 9.9707C17.867 10.0496 17.9299 10.143 17.9727 10.2461C18.0154 10.3492 18.0371 10.4597 18.0371 10.5713C18.0371 10.6828 18.0153 10.7934 17.9727 10.8965C17.9299 10.9996 17.867 11.0939 17.7881 11.1729L11.1729 17.7881C11.0939 17.867 10.9996 17.9299 10.8965 17.9727C10.7934 18.0153 10.6828 18.0371 10.5713 18.0371C10.4597 18.0371 10.3492 18.0154 10.2461 17.9727C10.143 17.9299 10.0496 17.867 9.9707 17.7881L2.21094 10.0283L2.1543 9.9668C2.1015 9.9028 2.05827 9.83083 2.02637 9.75391C1.98393 9.65143 1.9626 9.54157 1.96289 9.43066V2.1875C1.96289 2.12783 1.98613 2.07051 2.02832 2.02832C2.07051 1.98613 2.12783 1.96289 2.1875 1.96289ZM5.36426 4.31348C5.10481 4.36508 4.86674 4.49263 4.67969 4.67969C4.49263 4.86674 4.36508 5.10481 4.31348 5.36426C4.2619 5.62367 4.28843 5.89236 4.38965 6.13672C4.49088 6.38111 4.66189 6.59034 4.88184 6.7373C5.10178 6.88426 5.36048 6.96289 5.625 6.96289C5.97973 6.96289 6.31948 6.82114 6.57031 6.57031C6.82114 6.31948 6.96289 5.97973 6.96289 5.625C6.96289 5.36048 6.88426 5.10178 6.7373 4.88184C6.59034 4.66189 6.38111 4.49088 6.13672 4.38965C5.89236 4.28843 5.62367 4.2619 5.36426 4.31348Z"
              fill="url(#paint0_linear_67860_50530)"
              stroke="#FFC120"
              stroke-width="0.8"
            />
            <defs>
              <linearGradient
                id="paint0_linear_67860_50530"
                x1="9.99991"
                y1="1.5625"
                x2="9.99991"
                y2="18.4373"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFF8DB" />
                <stop offset="0.385023" stop-color="#FFE788" />
                <stop offset="0.680328" stop-color="#FFD54A" />
                <stop offset="1" stop-color="#FFC120" />
              </linearGradient>
            </defs>
          </svg>
          {bannerContent}
        </div>
        <Button
          className="absolute right-4"
          intent="iconOnly"
          onClick={onClose}
          variant="ghost-black"
          size="sm"
        >
          <X />
        </Button>
      </div>
    );
  }
}
